export interface FieldOption {
  label: string;
  value: string;
}

export interface RFQFieldConfig {
  key: string;
  label: string;
  type: "input" | "textarea" | "switch" | "select" | "calendar" | "uploader";
  required?: boolean;
  placeholder?: string;
  rows?: number;
  inputType?: string;
  step?: string;
  options?: FieldOption[];
  multiple?: boolean;
  maxSizeMB?: number;
}

export const formConfig: RFQFieldConfig[] = [
  {
    key: "quoteName",
    label: "Quote Name",
    type: "input",
    required: true,
    placeholder: "Enter quote name",
  },
  {
    key: "quantity",
    label: "Quantity",
    type: "input",
    inputType: "number",
    required: true,
    placeholder: "500",
  },
  {
    key: "description",
    label: "Product Description",
    type: "textarea",
    required: true,
    placeholder: "Describe your product specifications...",
    rows: 4,
  },
  {
    key: "offerSample",
    label: "Offer Sample",
    type: "switch",
  },
  {
    key: "productImages",
    label: "Product Images",
    type: "uploader",
    multiple: true,
    maxSizeMB: 10,
  },
  {
    key: "unitPrice",
    label: "Unit Price (USD)",
    type: "input",
    inputType: "number",
    step: "0.01",
    required: true,
    placeholder: "0.00",
  },
  {
    key: "totalAmount",
    label: "Total Amount (USD)",
    type: "input",
    inputType: "number",
    step: "0.01",
    required: true,
    placeholder: "0.00",
  },
  {
    key: "shippingTerms",
    label: "Shipping Terms",
    type: "select",
    required: true,
    options: [
      { label: "FOB", value: "fob" },
      { label: "CIF", value: "cif" },
      { label: "EXW", value: "exw" },
      { label: "DDU", value: "ddu" },
      { label: "DDP", value: "ddp" },
    ],
  },
  {
    key: "port",
    label: "Port/Location",
    type: "input",
    required: true,
    placeholder: "e.g. Shanghai, China",
  },
  {
    key: "deliveryTime",
    label: "Delivery Time",
    type: "input",
    required: true,
    placeholder: "e.g. 15-20 days",
  },
  {
    key: "paymentTerms",
    label: "Payment Terms",
    type: "select",
    required: true,
    options: [
      { label: "T/T 30% advance, 70% before shipment", value: "tt30" },
      { label: "T/T 50% advance, 50% before shipment", value: "tt50" },
      { label: "L/C at sight", value: "lc" },
      { label: "L/C 30 days", value: "lc30" },
      { label: "Cash in advance", value: "cash" },
      { label: "Net 30 days", value: "net30" },
    ],
  },
  {
    key: "expiryDate",
    label: "Quote Expiry Date",
    type: "calendar",
    required: true,
  },
  {
    key: "attachments",
    label: "Additional Files (Brochures, Certificates, etc.)",
    type: "uploader",
    multiple: true,
  },
  {
    key: "message",
    label: "Message to Buyer",
    type: "textarea",
    placeholder: "Additional information, special offers, or questions...",
    rows: 4,
  },
];
